// The template form's cards, shared by the template page and the create page
// so the form's wiring — Enter included — can't drift between the two.

import { Form } from "@/lib/forms";
import { CssCard, GeneralCard, LookCard } from "./template-sections";
import type { TemplateFormBinding } from "./use-template-form";

export function TemplateFormCards({ editor }: { editor: TemplateFormBinding }) {
    // spacing="none": kore's default space-y-6 on top of the gap doubled the
    // space between cards.
    return (
        <Form
            form={editor.form}
            onSubmit={editor.submit}
            onInvalid={editor.onInvalid}
            spacing="none"
            className="flex flex-col gap-6"
        >
            <GeneralCard control={editor.form.control} />
            <LookCard control={editor.form.control} fontChoice={String(editor.values.fontChoice)} />
            <CssCard control={editor.form.control} />
            {/* The save bar sits outside the form, and a browser submits on
                Enter only when the form holds a submit button of its own. */}
            <button type="submit" className="sr-only" tabIndex={-1} aria-hidden="true" />
        </Form>
    );
}
